/**
 * Write
 */

import Config from '../Config';
import Util from '../Util';
import Site from '../Site';
import DropdownLayer from '../DropdownLayer';
import DropdownLayer2Depth from '../DropdownLayer2Depth';
import ParamInfo from './ParamInfo';
import Template from './Template';
import GameInfo from '../GameInfo';

class Write {

    public onLoaded: any;

    private $node: any;

    private removeButtonName: string = `fe-remove-button`;

    private editor: any;

    private dropdownLayer: any;

    private isSubmit: boolean = false;

    private isReload: boolean = false;

    private isCancel: boolean = false;

    private updateData: any = {};

    private articleId: string;

    private paramInfo: ParamInfo;

    constructor( $node: any, options: any ) {
        const win = window as any;

        this.$node = $node;
        this.$node.addClass( Config.COMMUNITY_NODE );

        // loadedComplete
        this.onLoaded = new Util.Observer();
        this.onLoaded.add( () => {
            this.editor.onAppendContent();
        });

        this.articleId = Util.getParams().articleId;

        jQuery.extend( true, Config, options );

        Config.board = ( options.board ) ? options.board : Config.board;
        Config.isVote = ( options.isVote ) ? options.isVote : Config.isVote;
        Config.isServerBoard = ( options.isServerBoard ) ? options.isServerBoard : Config.isServerBoard;
        Config.isImage = ( options.isImage ) ? options.isImage : Config.isImage;
        Config.isEmoticon = ( options.isEmoticon ) ? options.isEmoticon : Config.isEmoticon;
        Config.onHookSubmitBefore = ( options.onHookSubmitBefore ) ? options.onHookSubmitBefore : '';
        Config.isShowWriteCategory = ( options.isShowWriteCategory ) ? options.isShowWriteCategory : Config.isShowWriteCategory;

        // Config.allowOnBeforeUnloadAlert
        this.$node.append( this.template() );

        // create Editor
        this.editor = new win.ui.RWDEditor( jQuery( '#froala-editor' ), Config.board, options );
        this.getCategory();
        this.addEvent();

        // parameter & hash Module - page, query, searchType, articleId
        this.paramInfo = new ParamInfo();
        this.paramInfo.setParamByUrl();

        if ( this.articleId ) {
            this.update();
        } else {
            this.loadedEnd();
        }
    }

    public getData() {
        return this.updateData;
    }

    public removeButtonUI() {
        return `<button class="fe-btn ${this.removeButtonName}"><i class="editor-icon-remove"><span hidden="">remove</span></i></button>`;
    }

    public update() {
        const viewUrl = Util.Tmpl.render({
            data: {articleId: this.articleId, board: Config.board},
            template: Config.view,
        });

        const viewPromise = Util.get( viewUrl );
        const get$ = Util.from( viewPromise );

        get$.subscribe( ( data: any ) => {
            const _article = data.article;
            const _uid = _article.writer.loginUser.uid;
            const _title = Util.decode( _article.title );
            const _contents = _article.contents;
            const gameCharacterName = _article.writer.gameUser.gameCharacterName;
            const gameServerId = _article.writer.gameUser.gameServerId;
            const _contentsInfo = {
                title: _title,
                contents: _contents,
                serverMaster: Site.serverMaster( data.article ),
            };
            let _$contents: any;

            if ( Config.guid === _uid || GameInfo.isEqualGameUser( gameCharacterName, gameServerId ) ) {
                jQuery( '#title' ).val( _title );
                _$contents = jQuery( '<div></div>' );
                _$contents.append( _contents );
                _$contents.find( 'img' ).after( this.removeButtonUI() );
                _$contents.find( '.fe-video .fe-video-inner iframe' ).after( this.removeButtonUI() );
                _$contents.find( '.fe-video, .img' ).addClass( 'fr-deletable' );
                this.editor.set( _$contents.html() );
            }
            // set aritlce Info
            this.updateData = data;
            this.onLoaded.emit( _contentsInfo );
        }, () => {
            this.onLoaded.emit( {} );
        });
    }

    public setCategoryUI( data: any ) {
        let tmp: any = [];
        let _categoryId = Util.getParams().categoryId;

        if ( Config.isShowCategory2Depth ) {
            // 2Depth
            tmp = data.categories;
            this.dropdownLayer = new DropdownLayer2Depth( jQuery( '.board-write-category' ), tmp, 'boardCategory' );

            if ( _categoryId ) {
                this.dropdownLayer.setValue( _categoryId );
            } else {
                this.dropdownLayer.setTextValue( Config.serverName[ GameInfo.getGameServerId() ] );
            }

        } else if ( Config.isServerBoard || Config.isCategory || Config.isShowCategory ) {
            // 1Depth
            data.forEach( ( item: any ) => {
                if ( item.activated ) {
                    tmp.push({
                        key: item.categoryId,
                        value: item.categoryName,
                    });
                }
            });

            if ( !tmp.length ) {
                return;
            }

            this.dropdownLayer = new DropdownLayer( jQuery( '.board-write-category' ), tmp, 'boardCategory' );

            if ( !_categoryId || _categoryId === '0' || _categoryId === '' ) {
                _categoryId = tmp[ 0 ].key;
            }

            this.dropdownLayer.setValue( _categoryId );
        }
    }

    public getCategory() {
        if ( !Config.isShowWriteCategory ) {
            return;
        }

        const categoryPromise = ( Config.isShowCategory2Depth ) ?
            Util.get( Config.category2depth( Config.board ), 'GET' ) :
            Util.get( Config.category( Config.board ), 'GET' );

        const category$ = Util.from( categoryPromise );
        category$.subscribe( ( data: any ) => {
            this.setCategoryUI( data );
        }, ( data: any ) => {
            Config.apiError( data );
        });
    }

    public onSubmitAfter( data: any ) {
        this.isSubmit = true;
        this.paramInfo.setParam( [ 'page', 1 ]  );
        this.paramInfo.setParam( ['searchType', '' ] );
        const articleId = (data && data.number) ? data.number : (this.articleId) ? this.articleId : '';

        if ( articleId !== '' ) {
            this.paramInfo.setParam( ['articleId', articleId ] );
            location.href = Config.viewPage + '?' + this.paramInfo.getParam();
        } else {
            location.href = Config.listPage + '?' + this.paramInfo.getParamIgnore( 'articleId' );
        }
    }

    public createTmpNode( str: string ) {
        const _$contents = jQuery( '<div></div>' );
        return _$contents.append( str );
    }

    public setTemplateByImages( images: any ) {
        let _tmp = '';
        for ( let idx = 0, len = images.length; len > idx; idx++ ) {
            const _images = images[ idx ];
            _tmp += this.editor.imagePlugin.template( _images );
        }

        const _$contents = this.createTmpNode( _tmp );
        _$contents.find( `.${this.removeButtonName}` ).remove();
        return _$contents.html();
    }

    public onSubmit( data: any, callback?: any ) {
        const _addImages = data.addImages;
        if ( _addImages && _addImages.length ) {
            data.contents += this.setTemplateByImages( _addImages );
            if ( !data.thumbnail ) {
                data.thumbnail = _addImages[ 0 ].fileUrl || _addImages[ 0 ].downloadurl || '';
            }
        }

        // allow write with all category
        if ( !Config.allowWriteWithAllCatecory && this.dropdownLayer ) {
            const categoryText = this.dropdownLayer.getTextValue();
            const reg = new RegExp( `${Config.L10N.all}` );

            if ( reg.test( categoryText ) ) {
                Config.alert( Config.L10N.alert_allow_write_select_category );
                this.enableWriteButton();
                return;
            }

            if ( this.dropdownLayer.getValue().toString() === '0' ) {
                Config.alert( Config.L10N.alert_allow_write_select_category );
                this.enableWriteButton();
                return;
            }
        }

        if ( Config.isImage && jQuery( data.contents ).find( 'img' ).length === 0 ) {
            Config.alert( Config.L10N.alert_empty_images );
            this.enableWriteButton();
            return;
        }

        const boardName =  ( data.boardAlias ) ? data.boardAlias : Config.board;
        const submitPromise = ( !this.articleId ) ?
            Util.get( Config.write( boardName ), 'POST', data ) :
            Util.get( Config.update({
                board: boardName,
                articleId: this.articleId,
            }), 'PUT', data );

        const submit$ = Util.from( submitPromise );

        submit$.subscribe( ( writeData: any ) => {
            if ( !callback ) {
                this.onSubmitAfter(writeData);
            } else {
                this.isSubmit = true;
                callback( writeData );
            }
        }, ( writeData: any ) => {
            this.isSubmit = true;
            Config.apiError( writeData );
            this.enableWriteButton();
        });
    }

    public submit( data: any, callback: any ) {
        if ( !data.title || !jQuery.trim( data.title ) ) {
            Config.alert( Config.L10N.alert_empty_title );
            this.enableWriteButton();
            return;
        }

        let _contents = data.contents;
        _contents = _contents.replace( /(<([^>]+)>)/ig, '' );
        _contents = _contents.replace( /&nbsp;/g, '' );
        _contents = _contents.replace( /\s/g, '' );

        if ( !_contents || this.editor.isEmpty() ) {
            Config.alert( Config.L10N.alert_empty_contents );
            this.enableWriteButton();
            return;
        }

        if ( Config.isVote ) {
            this.editor.voteSubmitBefore( data, ( submitData: any ) => {
                if ( submitData === 'error' ) {
                    this.enableWriteButton();
                } else {
                    this.submitBefore( submitData );
                }
            });
        } else {
            this.submitBefore( data );
        }
    }

    public submitBefore( data: any ) {
        if ( Config.onHookSubmitBefore ) {
            Config.onHookSubmitBefore( data );
        } else {
            this.onSubmit( data );
        }
    }

    public reset() {
        this.editor.reset();
    }

    public getThumbnail() {
        const contents = this.editor.getSubmitContents();
        const _$contents = this.createTmpNode( contents );
        let _image = _$contents.find( `.fe-image-inner img` ).not( '.fe-emoticon' ).eq( 0 ).attr( 'src' ) || ``;
        let _video = _$contents.find( `.fe-video:eq( 0 )` ).attr( 'data-contents-json' ) || ``;

        if ( _video ) {
            _video = JSON.parse( _video ).video_id;
            _video = this.setYoutubeThumb( _video );
        }

        if ( _image.indexOf( 'download' ) !== -1 ) {
            _image = _image.replace( 'download', 'download_thumbnail' );
        }

        return _image || _video || ``;
    }

    public disableWriteButton() {
        jQuery( '.boardWriteSubmit' ).prop( 'disabled', true );
    }

    public enableWriteButton() {
        jQuery( '.boardWriteSubmit' ).prop( 'disabled', false );
    }

    public loadedEnd() {
        jQuery( document ).ready( () => {
            this.onLoaded.emit();
        });
    }

    public gotoList() {
        this.isCancel = true;
        location.href = Config.listPage + '?' + this.paramInfo.getParamIgnore( 'articleId' );
    }

    public setYoutubeThumb( _video: string ) {
        return `https://img.youtube.com/vi/${_video}/0.jpg`;
    }

    private addEvent() {
        if ( Config.allowOnBeforeUnloadAlert ) {
            jQuery( window ).on( 'beforeunload', () => {
                if ( this.isSubmit ) {
                    return;
                } else if ( this.isReload ) {
                    return;
                } else if ( this.isCancel ) {
                    this.isCancel = false;
                    return;
                }
                return Config.L10N.alert_cancel_article;
            });
        }

        jQuery( 'body' ).on( 'click', '.boardWriteSubmit', ( evt ) => {
            evt.preventDefault();
            this.disableWriteButton();
            const contents = this.editor.getSubmitContents();
            const _title: any = jQuery( '#title' ).val();

            if ( this.editor.isImageUploading() ) {
                Config.alert( Config.L10N.alert_valid_upload );
                return;
            }

            if ( _title.length < 2 ) {
                Config.alert( Config.L10N.alert_too_short_title );
                this.enableWriteButton();
                return;
            }

            if ( _title.length > 50 ) {
                Config.alert( Config.L10N.alert_too_long_title );
                this.enableWriteButton();
                return;
            }

            const data: any = {
                // @TODO token怨� tokenId瑜� 紐⑤몢 �섍릿��.
                token: this.editor.getToken(),
                tokenId: this.editor.getToken(),
                // title: Util.escapeTag( _title ), //should not escape.
                title: _title,
                contents,
                thumbnail: this.getThumbnail(),
            };

            if ( this.articleId ) {
                data.articleId = this.articleId;
            }

            if ( this.dropdownLayer ) {
                data.categoryId = this.dropdownLayer.getValue();
                this.paramInfo.setParam( [ 'categoryId', data.categoryId ] );
            }

            this.submit( data, this.onSubmitAfter );
        });

        jQuery( 'body' ).on( 'click', '.boardWriteCancel', ( evt ) => {
            evt.preventDefault();

            if ( Config.allowOnBeforeUnloadAlert ) {
                Config.confirm( Config.L10N.alert_cancel_article, () => {
                    this.gotoList();
                }, () => {
                    // reject
                });
            } else {
                this.gotoList();
            }
        });
    }

    private template() {
        return `<div class="board-write">
		<form id="boardWriteForm" name="boardWriteForm" action="/board/${Config.board}/article" method="post" autocomplete="off" onSubmit="return false;">
			<input type="hidden" name="articleId" id="articleId" value="${this.articleId}" />
			${(Config.isShowCategory2Depth || (Config.isServerBoard || Config.isCategory || Config.isShowCategory) ) ? `<div class="board-write-category"></div>` : ``}

			<div class="board-write-title">
				<input type="text" name="title" id="title" maxlength="50" placeholder="${Config.L10N.title}" />
			</div>

			<div id="froala-editor"></div>

			<div class="co-btn-wrap">
				<div class="left">
					<button type="button" class="boardWriteCancel co-btn co-btn-write-cancel"><span>${Config.L10N.btn_cancel}</span></button>
				</div>
				<div class="right">
					<button type="button" class="boardWriteSubmit co-btn co-btn-round co-btn-write-submit"><i class="fe-icon-confirm"></i>${Config.L10N.btn_register}</button>
				</div>
			</div>
		</form>
		</div>`;
    }
}

export default Write;
